<template>
  <div>
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">Profile Qualifications</div>
      <v-spacer />
      <!-- <can I="create" a="ProfileQualification"> -->
        <v-btn color="secondary" round @click="addProfileQualification">
          <v-icon left>mdi-plus</v-icon> Add
        </v-btn>
      <!-- </can> -->
    </v-toolbar>

    <can I="list" a="ProfileQualification">
      <ProfileQualification
        v-for="pq in profileQualifications" :value="pq"
        :key="`profile-qualification-${pq.id}`"
        :flags="flags.filter(f => f.targetId == pq.id)"
        @refresh="refresh"
      />
    </can>
  </div>
</template>

<script>
// Components
import ProfileQualification from '@/components/profiles/ProfileQualification'

// Helpers
import { mapGetters, mapState } from 'vuex'

// Vue Component
export default {
  components: { ProfileQualification },
  props: {
    flags: { type: Array, default: [] },
  },
  computed: {
    ...mapGetters({ profile: 'admin/profiles/find' }),
    ...mapState('admin/profileQualifications', {
      allProfileQualifications: 'active',
    }),
    profileQualifications() {
      return this.allProfileQualifications
        .filter(pq => pq.profile.id == this.$route.params.id)
        .sort((a, b) => {
          if (a.endsAt > b.endsAt) return -1
          if (a.endsAt < b.endsAt) return 1
          return 0
        })
    },
  },
  methods: {
    refresh() {
      this.$store.dispatch('admin/profileQualifications/search', {
        filters: { profile: this.profile.id },
        sortBy: 'endsAt',
        descending: true,
      })
    },
    addProfileQualification() {
      if (
        this.allProfileQualifications.length == 0 ||
        (this.allProfileQualifications.length && this.allProfileQualifications[0].id)
      ) {
        this.allProfileQualifications.unshift({
          id: null,
          institutionName: '',
          institution: {},
          qualificationTypeName: '',
          qualificationType: {},
          specialization: '',
          qualification: {
            id: null,
            institution: {},
            qualificationType: {},
          },
          startsAt: null,
          endsAt: null,
          accreditedAt: null,
          profile: { id: this.$route.params.id },
          gradeScale: null,
          gradeValue: null,
          errors: null,
        })
      }
    },
  },
}
</script>
